import { render, staticRenderFns } from "./headerUser.vue?vue&type=template&id=1bc28b02&scoped=true"
import script from "./headerUser.vue?vue&type=script&lang=ts"
export * from "./headerUser.vue?vue&type=script&lang=ts"
import style0 from "./headerUser.vue?vue&type=style&index=0&id=1bc28b02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc28b02",
  null
  
)

export default component.exports